export default __webpack_public_path__ + "static/media/hht2_ep19_book_wp_02.884f85f6.jpg";